import React, { useEffect } from 'react';
import About from '../components/About';
import MediaInteractions from '../components/MediaInteractions';
import { mockData } from '../mock';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white pt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-16">
        <h1 className="text-6xl md:text-7xl font-bold mb-6">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
            About Rrammy
          </span>
        </h1>
        <p className="text-xl text-gray-400 max-w-3xl">
          Visionary filmmaker crafting compelling narratives that resonate with audiences worldwide.
        </p>
      </div>
      <About />
      <MediaInteractions />
      
      {/* Additional Info Section */}
      <section className="bg-gradient-to-b from-black to-gray-950 py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-amber-400">Philosophy</h2>
              <p className="text-gray-300 leading-relaxed">
                Every frame tells a story. My approach to filmmaking combines technical excellence with emotional depth, creating narratives that connect with audiences on a profound level. Whether it's a 30-second commercial or a feature-length narrative, the goal remains the same: authentic storytelling.
              </p>
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-amber-400">Approach</h2>
              <p className="text-gray-300 leading-relaxed">
                Collaboration is at the heart of great filmmaking. Working closely with brands, agencies, and creative teams, I bring visions to life through meticulous planning, innovative cinematography, and a deep understanding of visual language.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;